export const css = {
	root: '_12QMkpmb',
	titleBlock: '_2SUEP4hI',
	title: 'I5o1HOdr',
	eyebrow: '_2ZRD0c0K',
	openCloseIcon: 'a-sqBogi',
	close: '_1JGkFuPw',
	topicgroup: 'Ou7BIEPr',
	item: '_23LEy978',
	setTitleBlock: '_3CrFd1dX',
	emptyTitleBlock: '_2amKwUkH',
	actionBlock: '_2ddkxT5U',
	setTitle: '_6b-NfgxJ',
	setProgress: '_1_6U5LmC',
	setProficiency: '_2ApOMo_Z',
	accordionLegend: 'z2Hpuc8B',
	accordionLegendPlaceholder: '_3JtY2RZ9',
	accordionLegendProgress: '_2a8tQfKz',
	accordionLegendProficiency: '_2wAYRMJ2',
	accordionBody: '_2Xf3rGZM',
	itemWrapper: '_3epJkHSw',
	completed: '_2VxDW9ms',
	shortDesc: '_2qyNHUvp',
	truncate: '_203LibrB',
	status: '_14bgRQaG',
	progressBar: '_2B1zsXsz',
	whiteIcon: '_1a6gIvlI',
	openTitle: '_3wR2M3FQ',
	closedTitle: '_2H8SIXnv',
	statusLine: '_3m8rwyKP',
	' _key': 'ascm-theme/ascm/book-widgets/topicaccordion'
};

export default css;
